import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  markBatch: {
    total: 0,
    pending: 0,
    sent: 0,
  },
};

const assignmentsMarkSlice = createSlice({
  name: "assignmentsMark",
  initialState,
  reducers: {
    markBatch: (state, action) => {
      state.markBatch = action.payload;
    },
  },
});

export const { markBatch } = assignmentsMarkSlice.actions;
export default assignmentsMarkSlice.reducer;
